import PayrollHeader from './PayrollHeader';

export default PayrollHeader;
